import { z } from 'zod';
import { HTTP_STATUS } from './http-status';

/**
 * APIエラーレスポンスを型安全に扱うためのスキーマ定義
 * @see https://github.com/standandforce/dresscode-backend/pull/1152
 */
export const ErrorResponseSchema = z.object({
  statusCode: z.number().min(HTTP_STATUS.BAD_REQUEST).max(599),
  /** エラー種別の識別子。@see ERROR_CODE */
  code: z.string().optional(),
  timeStamp: z.string().datetime().transform(s => new Date(s)).optional(),
  systemMessage: z.union([z.string(), z.array(z.string())]).optional(),
  // 開発者向けのメッセージ(※do not display)
  /**
   * @deprecated 言語分の定義のあるメッセージ。こちらは使わないように縮小していくのが良い。 displayMessage を参照してください。
   */
  displayMessages: z.record(z.string(), z.string()).default({}),
  /** userLocale に基づいた displayMessages をサーバーでピックアップしたメッセージ */
  displayMessage: z.string().optional(),
  validationMessages: z.record(z.string(), z.array(z.string())).optional()
});
export type ErrorResponse = z.output<typeof ErrorResponseSchema>;

/**
 * 全体のパースに失敗したレスポンスから statusCode だけを救い出すためのスキーマ。
 * 他フィールドの形が想定と違うだけで status を失うと、4xx が 500 相当に化けてしまう。
 */
export const ErrorStatusCodeSchema = ErrorResponseSchema.pick({
  statusCode: true
});

/**
 * 全体のパースに失敗したレスポンスから code だけを救い出すためのスキーマ。
 * timeStamp 等の形の違いで code を失うと、問い合わせ時の切り分けができない。
 */
export const ErrorCodeSchema = ErrorResponseSchema.pick({
  code: true
});